import React, {useState, useEffect} from 'react'
import { Roles } from '../core-components/utility-components/UserUtils';
import * as S from "../../styles/ezev-fx-styles/LandingPage-styles";

function GroupDownloadPdf(props){
  const [disabledButton, setDisabledButton] = useState(true);
  
  function handleButtonClick() {
    props.openModal()
  }

     useEffect(() => {
       if(props.dataLoading || !props.energyGraphData) {
        setDisabledButton(true);
      } else {
        setDisabledButton(false);
      }
    },[props.energyGraphData, props.dataLoading])

  return(
    // Button is only for email reports and super admins and needs to be hidden in UI
    <S.PdfDownloadContainer style={{display: props.user.role >= Roles.SuperAdmin ? 'initial' : 'none'}}>
      <S.TableDownloadLink
        onClick={handleButtonClick}
        href={props.link}
        disabled={disabledButton}
        data-testid="condensedPdfDownload-testid"
        id='condensedPdfDownloadBtn'
      >
    Condensed PDF
      </S.TableDownloadLink>
    </S.PdfDownloadContainer>
  );
}

export default GroupDownloadPdf;
